import { type ErrorNamespace } from '../en-US/error';

export const error = {
  message: 'Esta página puede estar rota, pero afortunadamente somos un ministerio de salud, ¡así que la vamos a llevar al médico!',
  no_program_data_assistance: 'Si necesita ayuda ahora, comuníquese con nuestros Servicios para Miembros.',
  no_program_data_message: 'Estamos teniendo dificultades para recuperar sus datos.',
  timeout_contact_us: 'Mientras tanto, intente actualizar la página o comuníquese con nuestro Departamento de Servicios para Miembros:',
  timeout_message: 'Tenemos dificultades para recuperar sus datos o completar su solicitud. Nuestro equipo de ingenieros está investigando esto.',
  timeout_title: 'Huy! Algo salió mal',
  title: '¡Oh no!',
} as const satisfies ErrorNamespace;
